import { getAllLogs, getAllThreats, getAllIpEnrichments } from '../services/storage.js';
import { html, SEVERITY_SORT_DESC } from '../services/util.js';
import L from 'leaflet';

const template = document.createElement('template');
template.innerHTML = `
  <div class="section-header">
    <h1>World Map</h1>
    <div class="section-actions">
      <button class="btn btn-sm btn-secondary" id="map-refresh">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
        Refresh
      </button>
      <button class="btn btn-sm btn-secondary" id="map-toggle-filters">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="20" y2="12"/><line x1="12" y1="18" x2="20" y2="18"/></svg>
        Filters
      </button>
    </div>
  </div>

  <div class="map-filters" id="map-filters" style="display:none">
    <div class="filter-row">
      <span class="filter-label">Color by</span>
      <label class="filter-option">
        <input type="radio" name="color-mode" value="severity" checked>
        <span class="option-indicator"></span>
        Threat Severity
      </label>
      <label class="filter-option">
        <input type="radio" name="color-mode" value="result">
        <span class="option-indicator"></span>
        Login Result
      </label>
      <label class="filter-option">
        <input type="radio" name="color-mode" value="threatcount">
        <span class="option-indicator"></span>
        Threat Count
      </label>
    </div>
    <div class="filter-row">
      <span class="filter-label">Threat Status</span>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="status" value="active" checked>
        <span class="option-indicator"></span>
        Active
      </label>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="status" value="investigating" checked>
        <span class="option-indicator"></span>
        Investigating
      </label>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="status" value="resolved">
        <span class="option-indicator"></span>
        Resolved
      </label>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="status" value="clear">
        <span class="option-indicator"></span>
        No Threat
      </label>
    </div>
    <div class="filter-row">
      <span class="filter-label">Severity</span>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="severity" value="critical" checked>
        <span class="option-indicator"></span>
        Critical
      </label>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="severity" value="high" checked>
        <span class="option-indicator"></span>
        High
      </label>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="severity" value="medium" checked>
        <span class="option-indicator"></span>
        Medium
      </label>
      <label class="filter-option filter-option-check">
        <input type="checkbox" data-filter="severity" value="low" checked>
        <span class="option-indicator"></span>
        Low
      </label>
    </div>
    <div class="filter-row">
      <span class="filter-label">Basemap</span>
      <label class="filter-option">
        <input type="radio" name="basemap" value="light" checked>
        <span class="option-indicator"></span>
        Light
      </label>
      <label class="filter-option">
        <input type="radio" name="basemap" value="dark">
        <span class="option-indicator"></span>
        Dark
      </label>
    </div>
    <div class="filter-row">
      <span class="filter-label" style="white-space:nowrap">User</span>
      <input type="text" id="map-filter-user" placeholder="Filter by user..." style="flex:1;font-size:0.75rem;padding:2px 6px;border-radius:4px;border:1px solid var(--border-color);background:var(--bg-input);color:var(--text-primary);min-width:80px">
      <span class="filter-label" style="white-space:nowrap;margin-left:6px">IP</span>
      <input type="text" id="map-filter-ip" placeholder="Filter by IP..." style="flex:1;font-size:0.75rem;padding:2px 6px;border-radius:4px;border:1px solid var(--border-color);background:var(--bg-input);color:var(--text-primary);min-width:100px">
    </div>
    <div class="filter-row" style="border-top:1px solid var(--border-color);padding-top:6px;margin-top:4px">
      <span class="filter-label" style="white-space:nowrap">Time Range</span>
      <input type="date" id="map-date-from" style="font-size:0.75rem;padding:2px 6px;border-radius:4px;border:1px solid var(--border-color);background:var(--bg-input);color:var(--text-primary);width:auto">
      <span style="color:var(--text-muted);font-size:0.7rem">to</span>
      <input type="date" id="map-date-to" style="font-size:0.75rem;padding:2px 6px;border-radius:4px;border:1px solid var(--border-color);background:var(--bg-input);color:var(--text-primary);width:auto">
      <button class="btn btn-sm btn-secondary" id="map-play-btn" style="padding:2px 8px;font-size:0.7rem">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        Play
      </button>
    </div>
  </div>

  <div id="map-container" class="map-container"></div>

  <div class="map-legend" id="map-legend">
    <span class="map-legend-item"><span class="map-legend-dot" style="background:#4f8cff"></span>Normal login</span>
    <span class="map-legend-item"><span class="map-legend-dot" style="background:#34d399"></span>Low threat</span>
    <span class="map-legend-item"><span class="map-legend-dot" style="background:#fbbf24"></span>Medium threat</span>
    <span class="map-legend-item"><span class="map-legend-dot" style="background:#ef4444"></span>High/Critical</span>
  </div>
`;

export class WorldMap extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = template.innerHTML;
    this._map = null;
    this._markers = [];
    this._debounceTimer = null;
    this._playTimer = null;
    this._playIdx = 0;
    this._playPins = [];
    this._allPins = [];
    this._tileLayer = null;
    this._playHighlight = null;
  }

  connectedCallback() {
    const container = this.querySelector('#map-container');

    this.querySelector('#map-refresh').addEventListener('click', () => this.refresh());
    this.querySelector('#map-toggle-filters').addEventListener('click', () => this.toggleFilters());

    this.querySelectorAll('input[name="color-mode"]').forEach(el => {
      el.addEventListener('change', () => this.debounceRefresh());
    });
    this.querySelectorAll('input[name="basemap"]').forEach(el => {
      el.addEventListener('change', () => this.setBasemap(el.value));
    });
    this.querySelectorAll('[data-filter]').forEach(el => {
      el.addEventListener('change', () => this.debounceRefresh());
    });
    this.querySelector('#map-filter-user').addEventListener('input', () => this.debounceRefresh(true));
    this.querySelector('#map-filter-ip').addEventListener('input', () => this.debounceRefresh(true));
    this.querySelector('#map-date-from').addEventListener('change', () => this.debounceRefresh());
    this.querySelector('#map-date-to').addEventListener('change', () => this.debounceRefresh());
    this.querySelector('#map-play-btn').addEventListener('click', () => this.togglePlayback());

    if (!this._map) {
      this._map = L.map(container, {
        center: [20, 0],
        zoom: 2,
        zoomControl: true,
        attributionControl: true,
      });

      const savedBasemap = localStorage.getItem('threatscope:basemap') || 'light';
      const basemapRadio = this.querySelector(`input[name="basemap"][value="${savedBasemap}"]`);
      if (basemapRadio) basemapRadio.checked = true;

      const tileUrl = savedBasemap === 'dark'
        ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
        : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
      const tileAttr = savedBasemap === 'dark'
        ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>'
        : '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>';

      this._tileLayer = L.tileLayer(tileUrl, {
        attribution: tileAttr,
        maxZoom: 18,
      }).addTo(this._map);

      // Re-render markers when zoom changes (switch between clusters and individual pins)
      // preserveView=true prevents map from re-fitting bounds
      this._map.on('zoomend', () => this.debounceRefresh(true));
    }

    document.addEventListener('threatscope:stats-update', () => this.debounceRefresh());
    this.refresh();
  }

  toggleFilters() {
    const panel = this.querySelector('#map-filters');
    const btn = this.querySelector('#map-toggle-filters');
    const isOpen = panel.style.display !== 'none';
    panel.style.display = isOpen ? 'none' : '';
    btn.classList.toggle('active', !isOpen);
  }

  debounceRefresh(preserveView = false) {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => this.refresh(preserveView), 200);
  }

  invalidateSize() {
    if (this._map) {
      this._map.invalidateSize();
      this.refresh();
    }
  }

  async refresh(preserveView = false) {
    if (!this._map) return;

    this.stopPlayback();
    this._markers.forEach(m => this._map.removeLayer(m));
    this._markers = [];

    const colorMode = this.querySelector('input[name="color-mode"]:checked')?.value || 'severity';

    const statusFilters = [...this.querySelectorAll('[data-filter="status"]:checked')].map(cb => cb.value);
    const severityFilters = [...this.querySelectorAll('[data-filter="severity"]:checked')].map(cb => cb.value);
    const dateFrom = this.querySelector('#map-date-from').value;
    const dateTo = this.querySelector('#map-date-to').value;
    const userFilter = (this.querySelector('#map-filter-user').value || '').toLowerCase();
    const ipFilter = (this.querySelector('#map-filter-ip').value || '').toLowerCase();

    const [enrichments, threats] = await Promise.all([
      getAllIpEnrichments(),
      getAllThreats(),
    ]);

    const logs = await getAllLogs();

    if (logs.length === 0) {
      this.updateLegend(colorMode);
      return;
    }

    const enrichMap = {};
    enrichments.forEach(e => { enrichMap[e.ip] = e; });

    const threatByLogId = {};
    threats.forEach(t => {
      if (!threatByLogId[t.logId]) threatByLogId[t.logId] = [];
      threatByLogId[t.logId].push(t);
    });

    const visibleLogs = logs.filter(log => {
      if (dateFrom && log.timestamp && log.timestamp < dateFrom) return false;
      if (dateTo && log.timestamp) {
        const end = new Date(dateTo);
        end.setDate(end.getDate() + 1);
        if (log.timestamp >= end.toISOString().slice(0, 10)) return false;
      }

      if (userFilter && !(log.user || '').toLowerCase().includes(userFilter)) return false;
      if (ipFilter && !(log.ip || '').toLowerCase().includes(ipFilter)) return false;

      const logThreats = threatByLogId[log.id] || [];
      if (logThreats.length === 0) {
        return statusFilters.includes('clear');
      }
      return logThreats.some(t =>
        statusFilters.includes(t.status) &&
        severityFilters.includes(t.severity)
      );
    });

    const pinCounts = {};
    for (const log of visibleLogs) {
      const enrich = enrichMap[log.ip];
      if (!enrich || !enrich.lat || !enrich.lon) continue;

      const key = `${enrich.lat},${enrich.lon}`;
      if (!pinCounts[key]) {
        pinCounts[key] = {
          lat: enrich.lat, lon: enrich.lon, count: 0,
          logs: [], threats: [],
          country: enrich.country, city: enrich.city, ip: enrich.ip,
          successCount: 0, failureCount: 0,
        };
      }
      pinCounts[key].count++;
      pinCounts[key].logs.push(log);

      if (log.result === 'Success') {
        pinCounts[key].successCount++;
      } else if (log.result && log.result.includes('Failure')) {
        pinCounts[key].failureCount++;
      }

      const logThreats = threatByLogId[log.id] || [];
      for (const t of logThreats) {
        const exists = pinCounts[key].threats.some(et => et.logId === t.logId && et.type === t.type);
        if (!exists) {
          pinCounts[key].threats.push(t);
        }
      }
    }

    const rawPins = Object.values(pinCounts);
    if (rawPins.length === 0) {
      this.updateLegend(colorMode);
      return;
    }

    this._allPins = rawPins;

    const zoom = this._map.getZoom();
    const useClustering = zoom < 6;
    const clusters = useClustering ? this.clusterPins(rawPins, zoom) : rawPins;

    const markers = [];
    for (const pin of clusters) {
      let color;
      if (colorMode === 'result') {
        color = this.resultColor(pin);
      } else if (colorMode === 'threatcount') {
        color = this.threatCountColor(pin);
      } else {
        color = this.severityColor(pin);
      }

      const isCluster = pin.isCluster;
      const radius = isCluster
        ? Math.min(10 + Math.log2(pin.count) * 4, 30)
        : Math.min(6 + Math.log2(pin.count) * 3, 20);

      const borderColor = isCluster ? '#a78bfa' : '#fff';

      const marker = L.circleMarker(
        isCluster ? [pin.lat, pin.lon] : [pin.lat, pin.lon],
        {
          radius,
          fillColor: color,
          color: borderColor,
          weight: isCluster ? 2 : 1,
          opacity: 0.9,
          fillOpacity: isCluster ? 0.5 : 0.6,
        }
      );

      if (isCluster) {
        const clusterLogList = pin.logs.slice(0, 20).map(l =>
          `<div class="popup-log-row" data-log-id="${l.id}" style="padding:4px 0;border-bottom:1px solid #2e3245;cursor:pointer;display:flex;gap:6px;align-items:center;font-size:11px;">
            <span style="color:#6b6e85;white-space:nowrap">${l.timestamp ? new Date(l.timestamp).toLocaleString(undefined, {month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'}) : '-'}</span>
            <span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${html(l.user)}</span>
            <span class="badge ${l.result === 'Success' ? 'badge-status-resolved' : l.result && l.result !== '-' ? 'badge-status-active' : ''}" style="font-size:9px;padding:1px 6px">${html(l.result || '-')}</span>
          </div>`
        ).join('');
        const clusterOverflow = pin.count > 20 ? `<div style="color:#a78bfa;font-size:10px;text-align:center;padding:4px">+ ${pin.count - 20} more — zoom in to see all</div>` : '';
        const clusterRatioText = (pin.successCount + pin.failureCount) > 0
          ? ` &middot; ${pin.successCount} success, ${pin.failureCount} failure`
          : '';

        marker.bindPopup(`
          <div style="font-family:-apple-system,sans-serif;font-size:12px;min-width:280px;max-width:360px;">
            <div style="border-bottom:1px solid #2e3245;padding-bottom:6px;margin-bottom:4px;">
              <b>Cluster · ${pin.count} logins</b><br>
              <span style="color:#6b6e85">${pin.threats} threat(s)${clusterRatioText}</span>
            </div>
            <div style="max-height:200px;overflow-y:auto;margin:0 -4px;padding:0 4px;">
              ${clusterLogList}
              ${clusterOverflow}
            </div>
            <div style="color:#a78bfa;font-size:9px;text-align:center;padding-top:4px;border-top:1px solid #2e3245;margin-top:4px;">Click a row for details · Zoom in to see unclustered pins</div>
          </div>
        `);

        marker.on('popupopen', () => {
          const popup = marker.getPopup();
          const container = popup.getElement();
          if (!container) return;
          L.DomEvent.off(container);
          L.DomEvent.on(container, 'click', (e) => {
            const row = e.target.closest('.popup-log-row');
            if (!row) return;
            L.DomEvent.stopPropagation(e);
            const logId = Number(row.dataset.logId);
            const log = pin.logs.find(l => l.id === logId);
            if (log) {
              document.dispatchEvent(new CustomEvent('threatscope:show-detail', {
                detail: { type: 'log', log, enrichment: enrichMap[log.ip] },
              }));
            }
          });
        });
      } else {
        const logList = pin.logs.slice(0, 50).map(l =>
          `<div class="popup-log-row" data-log-id="${l.id}" style="padding:4px 0;border-bottom:1px solid #2e3245;cursor:pointer;display:flex;gap:6px;align-items:center;font-size:11px;">
            <span style="color:#6b6e85;white-space:nowrap">${l.timestamp ? new Date(l.timestamp).toLocaleString(undefined, {month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'}) : '-'}</span>
            <span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${html(l.user)}</span>
            <span class="badge ${l.result === 'Success' ? 'badge-status-resolved' : l.result && l.result !== '-' ? 'badge-status-active' : ''}" style="font-size:9px;padding:1px 6px">${html(l.result || '-')}</span>
          </div>`
        ).join('');

        const logOverflow = pin.count > 50 ? `<div style="color:#6b6e85;font-size:10px;text-align:center;padding:4px">+ ${pin.count - 50} more</div>` : '';
        const threatSummary = pin.threats.length > 0 ? ` &middot; ${pin.threats.length} threats` : '';
        const ratioText = (pin.successCount + pin.failureCount) > 0
          ? ` &middot; ${pin.successCount} success, ${pin.failureCount} failure`
          : '';

        marker.bindPopup(`
          <div style="font-family:-apple-system,sans-serif;font-size:12px;min-width:280px;max-width:360px;">
            <div style="border-bottom:1px solid #2e3245;padding-bottom:6px;margin-bottom:4px;">
              <b>${pin.city || 'Unknown'}, ${pin.country || 'Unknown'}</b><br>
              <span style="color:#6b6e85">IP: ${pin.ip} &middot; ${pin.count} logins${threatSummary}${ratioText}</span>
            </div>
            <div style="max-height:200px;overflow-y:auto;margin:0 -4px;padding:0 4px;">
              ${logList}
              ${logOverflow}
            </div>
            <div style="color:#6b6e85;font-size:9px;text-align:center;padding-top:4px;border-top:1px solid #2e3245;margin-top:4px;">Click a row to view details</div>
          </div>
        `);

        marker.on('popupopen', () => {
          const popup = marker.getPopup();
          const container = popup.getElement();
          if (!container) return;
          // Remove previous listeners to prevent leak on repeated popup opens
          L.DomEvent.off(container);
          L.DomEvent.on(container, 'click', (e) => {
            const row = e.target.closest('.popup-log-row');
            if (!row) return;
            L.DomEvent.stopPropagation(e);
            const logId = Number(row.dataset.logId);
            const log = pin.logs.find(l => l.id === logId);
            if (log) {
              document.dispatchEvent(new CustomEvent('threatscope:show-detail', {
                detail: { type: 'log', log, enrichment: enrichMap[log.ip] },
              }));
            }
          });
        });
      }

      markers.push(marker);
      this._map.addLayer(marker);
    }

    this._markers = markers;

    // Only fit bounds on initial render or data changes, not on zoom-driven refresh
    if (markers.length > 0 && !this._playTimer && !preserveView) {
      const group = L.featureGroup(markers);
      this._map.fitBounds(group.getBounds().pad(0.1));
    }

    this.updateLegend(colorMode);
  }

  clusterPins(pins, zoom) {
    const gridSize = Math.max(2, 12 - zoom) * 1.5;
    const clusters = {};
    for (const pin of pins) {
      const cx = Math.round(pin.lon / gridSize);
      const cy = Math.round(pin.lat / gridSize);
      const key = `${cx},${cy}`;
      if (!clusters[key]) {
        clusters[key] = {
          lat: pin.lat, lon: pin.lon, count: 0, threats: 0,
          latSum: 0, lonSum: 0, isCluster: true,
          successCount: 0, failureCount: 0,
          logs: [],
        };
      }
      const c = clusters[key];
      c.count += pin.count;
      c.threats += pin.threats.length;
      c.latSum += pin.lat * pin.count;
      c.lonSum += pin.lon * pin.count;
      c.successCount += pin.successCount;
      c.failureCount += pin.failureCount;
      // Collect logs for clickable popup rows
      for (const log of pin.logs) {
        c.logs.push(log);
      }
    }
    return Object.values(clusters).map(c => ({
      ...c,
      lat: c.latSum / c.count,
      lon: c.lonSum / c.count,
    }));
  }

  severityColor(pin) {
    const severity = pin.threats.reduce((max, t) => {
      return SEVERITY_SORT_DESC[t.severity] > SEVERITY_SORT_DESC[max] ? t.severity : max;
    }, 'none');
    switch (severity) {
      case 'critical': return '#ef4444';
      case 'high': return '#fb923c';
      case 'medium': return '#fbbf24';
      case 'low': return '#34d399';
      default: return '#4f8cff';
    }
  }

  resultColor(pin) {
    const total = pin.successCount + pin.failureCount;
    if (total === 0) return '#4f8cff';
    const ratio = pin.failureCount / total;
    if (ratio === 0) return '#34d399';
    if (ratio < 0.25) return '#84cc16';
    if (ratio < 0.5) return '#fbbf24';
    if (ratio < 0.75) return '#fb923c';
    return '#ef4444';
  }

  threatCountColor(pin) {
    const count = pin.threats ? pin.threats.length : 0;
    if (count === 0) return '#4f8cff';
    if (count <= 1) return '#34d399';
    if (count <= 3) return '#fbbf24';
    if (count <= 6) return '#fb923c';
    return '#ef4444';
  }

  updateLegend(mode) {
    const legend = this.querySelector('#map-legend');
    if (mode === 'result') {
      legend.innerHTML = `
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#34d399"></span>All success</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#84cc16"></span>&lt;25% fail</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#fbbf24"></span>&lt;50% fail</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#fb923c"></span>&lt;75% fail</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#ef4444"></span>All failure</span>
      `;
    } else if (mode === 'threatcount') {
      legend.innerHTML = `
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#4f8cff"></span>0 threats</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#34d399"></span>1 threat</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#fbbf24"></span>2-3 threats</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#fb923c"></span>4-6 threats</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#ef4444"></span>7+ threats</span>
      `;
    } else {
      legend.innerHTML = `
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#4f8cff"></span>Normal login</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#34d399"></span>Low threat</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#fbbf24"></span>Medium threat</span>
        <span class="map-legend-item"><span class="map-legend-dot" style="background:#ef4444"></span>High/Critical</span>
      `;
    }
  }

  _createPlaybackMarkers() {
    // Fallback: create markers from _allPins when refresh() hasn't rendered any
    // so Play button always works as a way to reveal pins
    for (const pin of this._allPins) {
      const color = '#4f8cff';
      const marker = L.circleMarker([pin.lat, pin.lon], {
        radius: Math.min(6 + Math.log2(pin.count) * 3, 20),
        fillColor: color,
        color: '#fff',
        weight: 1,
        opacity: 0.8,
        fillOpacity: 0.6,
      });
      this._map.addLayer(marker);
      this._markers.push(marker);
    }
    // Dim newly created markers for playback reveal
    this._markers.forEach(m => {
      if (m.setStyle) m.setStyle({ fillOpacity: 0.25, opacity: 0.5 });
    });
  }

  setBasemap(mode) {
    localStorage.setItem('threatscope:basemap', mode);
    const url = mode === 'dark'
      ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
      : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    const attr = mode === 'dark'
      ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>'
      : '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>';

    if (this._map && this._tileLayer) {
      this._map.removeLayer(this._tileLayer);
      this._tileLayer = L.tileLayer(url, {
        attribution: attr,
        maxZoom: 18,
      }).addTo(this._map);
    }
  }

  togglePlayback() {
    if (this._playTimer) {
      this.stopPlayback();
      return;
    }
    if (this._allPins.length === 0) return;

    const sorted = this._allPins.slice().sort((a, b) => {
      const aTime = a.logs.reduce((min, l) => l.timestamp && l.timestamp < min ? l.timestamp : min, '9999');
      const bTime = b.logs.reduce((min, l) => l.timestamp && l.timestamp < min ? l.timestamp : min, '9999');
      return aTime.localeCompare(bTime);
    });

    this._playPins = sorted;
    this._playIdx = 0;

    // Additive playback: dim existing markers (or create them if refresh() hasn't rendered any)
    if (this._markers.length === 0) {
      this._createPlaybackMarkers();
    } else {
      this._markers.forEach(m => {
        if (m.setStyle) m.setStyle({ fillOpacity: 0.25, opacity: 0.5 });
      });
    }

    const btn = this.querySelector('#map-play-btn');
    btn.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg> Pause';

    this._playTimer = setInterval(() => this.playbackStep(), 400);
  }

  playbackStep() {
    if (this._playIdx >= this._playPins.length) {
      this.stopPlayback();
      return;
    }
    const pin = this._playPins[this._playIdx++];

    // Remove previous highlight
    if (this._playHighlight && this._map) {
      this._map.removeLayer(this._playHighlight);
    }

    // Create temporary highlight ring at current pin
    this._playHighlight = L.circleMarker([pin.lat, pin.lon], {
      radius: 20,
      fillColor: '#ffd700',
      color: '#ffd700',
      weight: 2,
      opacity: 0.6,
      fillOpacity: 0.15,
      interactive: false,
    });
    this._map.addLayer(this._playHighlight);
  }

  stopPlayback() {
    if (this._playTimer) {
      clearInterval(this._playTimer);
      this._playTimer = null;
    }

    // Remove highlight ring
    if (this._playHighlight && this._map) {
      this._map.removeLayer(this._playHighlight);
      this._playHighlight = null;
    }

    // Restore marker opacity
    this._markers.forEach(m => {
      if (m.setStyle) m.setStyle({ fillOpacity: 0.6, opacity: 0.9 });
    });

    this._playIdx = 0;
    this._playPins = [];
    const btn = this.querySelector('#map-play-btn');
    if (btn) btn.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg> Play';
  }

  disconnectedCallback() {
    if (this._map) {
      this._map.remove();
      this._map = null;
    }
  }

}

customElements.define('world-map', WorldMap);
